import { HorizontalTrackerStep } from './HorizontalTrackerStep';
import { HorizontalTrackerContainer } from './styles';
import type { TrackerBarPositionVariant, TrackerBarVariant } from './types';

export interface HorizontalTrackerProps {
  totalSteps: number;
  currentStepIdx: number;
  variant: 'active' | 'inactive';
}

export const HorizontalTracker = ({ totalSteps, currentStepIdx, variant }: HorizontalTrackerProps) => {
  const steps = [];
  for (let i = 0; i < totalSteps; i++) {
    const isCurrent = i === currentStepIdx;
    const isFirst = i === 0;
    const isLast = i === totalSteps - 1;
    const isPast = i <= currentStepIdx;
    const isActive = variant === 'active';
    const position: TrackerBarPositionVariant = isFirst ? 'first' : isLast ? 'last' : 'middle';
    const barVariant: TrackerBarVariant = !isPast
      ? 'future'
      : isActive
      ? 'active'
      : isCurrent
      ? 'inactiveCurrent'
      : 'inactive';
    const step = <HorizontalTrackerStep barVariant={barVariant} position={position} isCurrent={isCurrent} key={i} />;
    steps.push(step);
  }
  return <HorizontalTrackerContainer>{steps}</HorizontalTrackerContainer>;
};
